import type { MapaCargo } from '@/components/Configuracao/mapaCargos/mapaCargosTypes'

export const CARGO_ANALISTA_DE_SEO: MapaCargo = 
{
  id: 'analista-de-seo',
  titulo: 'Analista de SEO',
  setor: 'Performance',
  secoes: [
    {
      id: 'planejamento-e-execucao-de-conteudo-estrategico',
      titulo: 'Planejamento e execução de conteúdo estratégico',
      atividades: [
        'Criar planos de conteúdo baseados em intenções de busca e volume de pesquisa.',
        'Criar e sugerir conteúdos (blog posts, vídeos, infográficos) para melhorar o tráfego orgânico.',
      ],
    },
    {
      id: 'gestao-de-backlinks-off-page-seo',
      titulo: 'Gestão de backlinks (Off-Page SEO)',
      atividades: [
        'Identificar oportunidades para aquisição de backlinks de qualidade.',
        'Monitorar e remover backlinks tóxicos que podem prejudicar o desempenho do site.',
      ],
    },
    {
      id: 'otimizacao-para-dispositivos-moveis',
      titulo: 'Otimização para dispositivos móveis',
      atividades: [
        'Garantir que o site seja responsivo e que a experiência do usuário seja otimizada para dispositivos móveis.',
        'Analisar métricas específicas de mobile, como Core Web Vitals.',
      ],
    },
    {
      id: 'analise-tecnica-avancada',
      titulo: 'Análise técnica avançada',
      atividades: [
        'Verificar problemas de crawlability e indexabilidade usando ferramentas como Screaming Frog, SEMrush, ou Ahrefs.',
        'Analisar e otimizar mapas de site XML, arquivos robots.txt, e links internos.',
      ],
    },
    {
      id: 'monitoramento-de-tendencias-de-palavras-chave',
      titulo: 'Monitoramento de tendências de palavras-chave',
      atividades: [
        'Usar ferramentas como Google Trends para identificar variações sazonais e novas oportunidades.',
        'Atualizar estratégias com base em mudanças nos interesses dos usuários.',
      ],
    },
    {
      id: 'seo-para-e-commerce',
      titulo: 'SEO para e-commerce',
      atividades: [
        'Otimizar páginas de produtos e categorias para buscas comerciais.',
        'Configurar e melhorar rich snippets (ex.. avaliações, preços) para destacar produtos nos resultados de busca.',
      ],
    },
    {
      id: 'implementacao-de-dados-estruturados-schema-markup',
      titulo: 'Implementação de dados estruturados (Schema Markup)',
      atividades: [
        'Aplicar marcações estruturadas para melhorar a visualização do site nos resultados dos buscadores.',
        'Testar e validar a implementação de schema com ferramentas como o Rich Results Test.',
      ],
    },
  ],
}
